module.exports = fox._r("images/bg-px.png", __webpack_public_path__ + "_/_/_/common/frame/images/bg-px.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/bg-px.png
// module id = 139
// module chunks = 2